import dayjs from 'dayjs';
import { isNil, isEmpty } from 'lodash-es';
import type { WorkCalendarYearResponse } from './dtoModels/workCalendarResponse';
import type { WorkCalendarDay } from 'models/calendar';

const BASE_URL = 'https://calendar.kuzyak.in/api';

/**
 * Получает информацию о праздниках и выходных днях для указанного года
 *
 * @param year год
 * @returns Promise с информацией о праздниках и выходных днях
 */
export const getYearCalendar = async (
  year: number
): Promise<WorkCalendarYearResponse> => {
  const response = await fetch(`${BASE_URL}/calendar/${year}/holidays`);
  if (!response.ok) {
    throw new Error(`Failed to fetch calendar data: ${response.statusText}`);
  }
  return await response.json();
};

/**
 * Преобразует данные от API в формат для использования в приложении
 *
 * @param data данные календаря от API
 * @returns массив дней с информацией о праздниках и сокращенных днях
 */
export const transformCalendarData = (
  data: WorkCalendarYearResponse
): WorkCalendarDay[] => {
  const result = new Map<string, WorkCalendarDay>();

  // Праздничные дни
  data.holidays.forEach((holiday) => {
    result.set(holiday.date, {
      date: dayjs(holiday.date),
      name: holiday.name,
      isHoliday: true,
      isShortDay: false,
    });
  });

  // Сокращенные дни
  data.shortDays.forEach((shortDay) => {
    const existingDay = result.get(shortDay.date);
    if (!isNil(existingDay)) {
      existingDay.isShortDay = true;
      if (isEmpty(existingDay.name) && !isEmpty(shortDay.name)) {
        existingDay.name = shortDay.name;
      }
    } else {
      result.set(shortDay.date, {
        date: dayjs(shortDay.date),
        name: shortDay.name,
        isHoliday: false,
        isShortDay: true,
      });
    }
  });

  return Array.from(result.values());
};
